import { StringSchema } from 'yup';

export default function positiveNumber(this: StringSchema, message: string) {
  return this.test('positiveNumber', message, (value) => Number(value) >= 1);
}
